import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { EditCampaignModel, CampaignSlideModel, CampaignSlide, CampaignPersistType } from "../../../models/inModels/campaign";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { CampaignService } from "../../../services/campaign.service";
import { StorageService } from "../../../services/system/storage.service";
import { SelectItem } from "primeng/components/common/selectitem";

@Component({
	selector: 'app-campaigns-edit',
	templateUrl: './campaigns-edit.component.html',
	styleUrls: ['./campaigns-edit.component.css']
})
export class CampaignsEditComponent implements OnInit {
	id: number;
	model: EditCampaignModel;
	loading = true;
	error: Message[];
	messages: Message[];
	locations: SelectItem[];
	selectedLocation: SelectItem;
	slides: CampaignSlide[];
	slideModel: CampaignSlideModel;
	uploading = false;
	file: any;
	edit = false;
	slideEditModel: CampaignSlideModel;
	types: SelectItem[];
	selectedType: SelectItem;
	constructor(
		private storageService: StorageService,
		private auth: AuthenticationService,
		private route: ActivatedRoute,
		private router: Router,
		private service: CampaignService) {
		this.id = Number(this.route.snapshot.paramMap.get('Id'));
		this.slideModel = new CampaignSlideModel();
		this.slideModel.CampaignId = this.id;
	}

	ngOnInit() {
		this.get();
	}

	initDropDown(event) {
		this.service.getDropdown(event).then(
			x => {
				this.locations = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setLocation(): void {
		this.model.Url = this.selectedLocation.value;
	}

	get() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				console.log(result);
				this.model = new EditCampaignModel(result);
				this.slides = result.Slides;
				this.selectedType = {
					label: CampaignPersistType[result.PersistType],
					value: result.PersistType
				};
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/campaigns']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleFile(event, model: CampaignSlideModel): void {
		var result = this.storageService.handleSuccess(event);
		this.file = result;
		model.DocumentId = result.Id;
		this.uploading = false;
	}

	handleError(event): void {
		this.uploading = false;
		this.messages = [];
		this.storageService.handleError(event, this.messages);
	}

	addSlide() {
		this.loading = true;
		this.service.addSlide(this.slideModel).then(
			result => {
				this.slideModel = new CampaignSlideModel();
				this.slideModel.CampaignId = this.id;
				this.file = null;
				this.loading = false;
				this.get();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	editSlide(slide: CampaignSlide) {
		console.log(slide);
		this.slideEditModel = new CampaignSlideModel(slide);
		this.edit = true;
	}

	saveSlide() {
		this.loading = true;
		this.service.updateSlide(this.slideEditModel).then(
			result => {
				this.loading = false;
				this.get();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	deleteSlide(slide: CampaignSlide) {
		this.loading = true;
		this.service.deleteSlide(new CampaignSlideModel(slide)).then(
			result => {
				this.get();
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initDropDownTypes(event) {
		this.service.getDropdownTypes(event).then(
			x => {
				this.types = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setType(): void {
		this.model.PersistType = this.selectedType.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/campaigns/campaigns-edit/campaigns-edit.component.ts